import { render, staticRenderFns } from "./NewRemarkPopup.vue?vue&type=template&id=4d3b734a&scoped=true&"
import script from "./NewRemarkPopup.vue?vue&type=script&lang=js&"
export * from "./NewRemarkPopup.vue?vue&type=script&lang=js&"
import style0 from "./NewRemarkPopup.vue?vue&type=style&index=0&id=4d3b734a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3b734a",
  null
  
)

export default component.exports